import { log } from '@libs/utils';

import type { GoogleAnalyticsEvent } from './eventsTypes';

declare global {
  interface Window {
    dataLayer?: object[];
  }
}

export function trackGoogleAnalyticsEvent(
  eventName: GoogleAnalyticsEvent,
  objectPushedToDataLayer?: Record<string, unknown>
): void {
  const dataLayerObject = {
    event: eventName,
    ...objectPushedToDataLayer,
  };

  log({ title: 'GA', context: [dataLayerObject] });

  if (window.dataLayer) {
    window.dataLayer.push(dataLayerObject);
  }
}
